export const Highcharts_lang_se = {
  loading: "Laddar...",
  months: [
    "Januari",
    "Februari",
    "Mars",
    "April",
    "Maj",
    "Juni",
    "Juli",
    "Augusti",
    "September",
    "Oktober",
    "November",
    "December",
  ],
  weekdays: [
    "Söndag",
    "Måndag",
    "Tisdag",
    "Onsdag",
    "Torsdag",
    "Fredag",
    "Lördag",
  ],
  shortMonths: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "Maj",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dec",
  ],
  exportButtonTitle: "Exportera",
  printButtonTitle: "Skriv ut",
  rangeSelectorfrån: "Från",
  rangeSelectorTo: "Till",
  rangeSelectorZoom: "Period",
  accessibility: {
    chartContainerLabel: "{title}. Grade Highcharts interaktiv graf.. ",
    svgContainerLabel: "",
    axis: {
      rangeCategories: "Dataområde: {numCategories} kategorier.",
      rangefrånTo: "Dataområde från {rangefrån} till {rangeTo}.",
      timeRangeDays: "Dataområde: {range} dagar.",
      timeRangeHours: "Dataområde: {range} timmar.",
      timeRangeMinutes: "Dataområde: {range} minuter.",
      timeRangeSeconds: "Dataområde: {range} sekunder.",
      xAxisDescriptionPlural:
        "Diagrammet har {numAxes} X axlar som visar {#each(names, -1), }och {names[-1]}.",
      xAxisDescriptionSingular:
        "Diagrammet har 1 X axel som visar {names[0]}. {ranges[0]}",
      yAxisDescriptionPlural:
        "Diagrammet har {numAxes} Y axlar som visar {#each(names, -1), }och {names[-1]}.",
      yAxisDescriptionSingular:
        "Diagrammet har 1 Y axel som visar {names[0]}. {ranges[0]}",
    },
    exporting: {
      chartMenuLabel: "Diagrammeny",
      menuButtonLabel: "Visa diagrammeny, {chartTitle}",
    },
    legend: {
      legendItem: "Visa {itemName}",
      legendLabel: "diagramlegenden: {legendTitle}",
      legendLabelNoTitle: "Växla seriernas synlighet, {chartTitle}",
    },
    rangeSelector: {
      clickButtonAnnouncement: "Visar {axisRangeDescription}",
      maxInputLabel: "Välj slutdatum.",
      minInputLabel: "Välj startdatum.",
    },
    screenReaderSection: {
      annotations: {
        descriptionMultiplePoints:
          "{annotationText}. Relaterad till {annotationPoint}{ Även relaterat till, #each(additionalAnnotationPoints)}",
        descriptionNoPoints: "{annotationText}",
        descriptionSinglePoint:
          "{annotationText}. Relaterad till {annotationPoint}",
        heading: "Sammanfattning av diagramanteckningar",
      },
      endOfChartMarker: "Slut på interaktivt diagram.",
    },
    series: {
      description: "{description}",
      nullPointValue: "Inget värde",
      pointAnnotationsDescription: "{Annotation: #each(annotations). }",
      summary: {
        bar: "{series.name},bar serie {seriesNumber} av {chart.series.length} med {series.points.length} {#plural(series.points.length, staplar, stapel)}.",
        barCombination:
          "{series.name}, series {seriesNumber} av {chart.series.length}. Bar serie med {series.points.length} {#plural(series.points.length, staplar, stapel)}.",
        boxplot:
          "{series.name}, boxplot {seriesNumber} av {chart.series.length} med {series.points.length} {#plural(series.points.length, boxar, box)}.",
        boxplotCombination:
          "{series.name}, series {seriesNumber} av {chart.series.length}. Boxplot med {series.points.length} {#plural(series.points.length, boxar, box)}.",
        bubble:
          "{series.name}, bubble serie {seriesNumber} av {chart.series.length} med {series.points.length} {#plural(series.points.length, bubblor, bubbla)}.",
        bubbleCombination:
          "{series.name}, series {seriesNumber} av {chart.series.length}. Bubble serie med {series.points.length} {#plural(series.points.length, bubblor, bubbla)}.",
        column:
          "{series.name},bar serie {seriesNumber} av {chart.series.length} med {series.points.length} {#plural(series.points.length, staplar, stapel)}.",
        columnCombination:
          "{series.name}, serie {seriesNumber} av {chart.series.length}. Bar serie med {series.points.length} {#plural(series.points.length, staplar, stapel)}.",
        default:
          "{series.name}, serie {seriesNumber} av {chart.series.length} med {series.points.length} data {#plural(series.points.length, punkter, punkt)}.",
        defaultCombination:
          "{series.name}, series {seriesNumber} av {chart.series.length} med {series.points.length} data {#plural(series.points.length, punkter, punkt)}.",
        line: "{series.name}, line {seriesNumber} av {chart.series.length} med {series.points.length} data {#plural(series.points.length, punkter, punkt)}.",
        lineCombination:
          "{series.name}, series {seriesNumber} av {chart.series.length}. Linje med {series.points.length} data {#plural(series.points.length, punkter, punkt)}.",
        map: "{series.name}, karta {seriesNumber} av {chart.series.length} med {series.points.length} {#plural(series.points.length, areor, area)}.",
        mapbubble:
          "{series.name}, bubble series {seriesNumber} av {chart.series.length} med {series.points.length} {#plural(series.points.length, bubblor, bubbla)}.",
        mapbubbleCombination:
          "{series.name}, series {seriesNumber} av {chart.series.length}. Bubble serie med {series.points.length} {#plural(series.points.length, bubblor, bubbla)}.",
        mapCombination:
          "{series.name}, series {seriesNumber} av {chart.series.length}. Karta med {series.points.length} {#plural(series.points.length, areor, area)}.",
        mapline:
          "{series.name}, line {seriesNumber} av {chart.series.length} med {series.points.length} data {#plural(series.points.length, punkter, punkt)}.",
        maplineCombination:
          "{series.name}, serie {seriesNumber} av {chart.series.length}. Linje med {series.points.length} data {#plural(series.points.length, punkter, punkt)}.",
        pie: "{series.name}, pie {seriesNumber} av {chart.series.length} med {series.points.length} {#plural(series.points.length, delar, del)}.",
        pieCombination:
          "{series.name}, serie {seriesNumber} av {chart.series.length}. Cirkeldiagram med {series.points.length} {#plural(series.points.length, delar, del)}.",
        scatter:
          "{series.name}, spridningsdiagram {seriesNumber} av {chart.series.length} med {series.points.length} {#plural(series.points.length, punkter, punkt)}.",
        scatterCombination:
          "{series.name}, serie {seriesNumber} av {chart.series.length}, spridningsdiagram med {series.points.length} {#plural(series.points.length, punkter, punkt)}.",
        spline:
          "{series.name}, line {seriesNumber} av {chart.series.length} med {series.points.length} data {#plural(series.points.length, punkter, punkt)}.",
        splineCombination:
          "{series.name}, serie {seriesNumber} av {chart.series.length}. Linje med {series.points.length} data {#plural(series.points.length, punkter, punkt)}.",
      },
      xAxisDescription: "X axel, {name}",
      yAxisDescription: "Y axel, {name}",
    },
    table: {
      tableSummary: "Tabellformulering av diagrammet.",
      VisaAsDataTableButtonText: "Visa som datatabell, {chartTitle}",
    },
    zoom: {
      mapZoomIn: "Zooma diagrammet",
      mapZoomOut: "Zooma ut diagrammet",
      resetZoomButton: "Återställ zoom",
    },
  },
};
